<template>
    <div class="vertical-container vertical-container--in-secondary-content">
        <div class="vertical-container__header vertical-container__header--has-shadow">
            <div class="container">
                <h1>{{ title }}
                    <custom-button @click="updateTitle" iconic class="project-name-update"><span icon edit></span>upravit
                    </custom-button>
                </h1>
            </div>
        </div>

        <div class="vertical-container__content">
            <main-container/>
        </div>
    </div>
</template>

<script>
import MainContainer from '@/modules/ProjectModule/modules/OptionModule/components/Main/MainContainer';
import UpdateProjectTitleDialog from '@/modules/ProjectModule/components/Project/UpdateProjectTitleDialog';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name: 'ProjectMainView',
    components: {CustomButton, MainContainer},
    computed: {
        title() {
            return this.$store.getters['projects/project/title'];
        }
    },
    methods: {
        updateTitle() {
            this.$modal.show(UpdateProjectTitleDialog, {}, defaultModalParameters())
        }
    }
}
</script>
